import {
  Avatar,
  Dialog,
  DialogContent,
  Typography,
  useTheme,
} from "@mui/material";
import "./index.css";
import Logo from "../../../../assets/images/logo.svg";
import { MessageType } from "./types";
import { useSelector } from "react-redux";
import { useState } from "react";
import { IoDocumentText } from "react-icons/io5";
import { RiClaudeFill, RiOpenaiFill } from "react-icons/ri";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/github.css"; // Or any other style

export default function Messages(props: {
  messages: Array<MessageType>;
  mode: string;
  selectedLlm: string | undefined;
}) {
  const metaData = useSelector((state: any) => state.metaData);
  const { firstName, lastName, personalThread } = metaData.userInfo;
  const [expandImage, setExpandImage] = useState<any>("");
  const theme = useTheme();
  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: "#2a945f",
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  const llmIcon = (llm: string) => {
    switch (llm) {
      case "claude":
        return <RiClaudeFill color={theme.palette.primary.main} size={25} />;
      case "openai":
        return <RiOpenaiFill color={theme.palette.primary.main} size={25} />;
    }
  };

  const message = (msg: MessageType, i: number) => {
    return msg.role == "system" &&
      (msg.messageContent == "Thread Hydrated" ||
        msg.messageContent == "LLM Switched") ? (
      <div key={i}>
        <h3 className="thread-hydrated">
          <div style={{ flex: 1 }}>
            Thread <b style={{ color: "#2a945f" }}>Hydrated</b>
          </div>
          {msg.messageTimestamp ? (
            <div className="msg-time">
              {new Date(msg.messageTimestamp).toLocaleDateString() +
                " - " +
                new Date(msg.messageTimestamp).toLocaleTimeString()}
            </div>
          ) : null}
          <div>{msg.aiModel ? llmIcon(msg.aiModel) : ""}</div>
        </h3>
        <hr style={{ border: "1px solid #2a945f" }} />
      </div>
    ) : (
      <div
        className="msg-box"
        key={i}
        id={`msgid-${msg.message_id}`}
        style={{
          justifyContent: msg.role == "user" ? "flex-end" : "flex-start",
        }}
      >
        {msg.role == "user" ? (
          <></>
        ) : (
          <Avatar
            alt="Remy Sharp"
            sx={{
              objectFit: "contain",
              backgroundColor: "#2a945f",
            }}
          >
            <img src={Logo} className="bot-avatar" />
          </Avatar>
        )}
        <div
          className={msg.role == "user" ? "user-msg" : "bot-msg"}
          style={{ marginTop: "2px" }}
        >
          <div
            className={
              msg.messageContent
                ? msg.role == "user"
                  ? "msg-text"
                  : "bot-text"
                : props.mode == "dark"
                ? personalThread
                  ? "p-dark-loader"
                  : "dark-loader"
                : personalThread
                ? "p-light-loader"
                : "light-loader"
            }
          >
            {msg.messageType == "file" &&
            msg.contentMetaData &&
            msg.contentMetaData.length ? (
              <div
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                {msg.contentMetaData.map((metaData) => {
                  return (
                    <a
                      className="message-file"
                      href={metaData.fileUrl}
                      download
                    >
                      <IoDocumentText
                        style={{ width: "25px", height: "25px" }}
                      />
                      <div style={{ fontStyle: "italic" }}>
                        {metaData.fileName}
                      </div>
                    </a>
                  );
                })}
              </div>
            ) : null}
            {msg.messageType == "text" || msg.messageType == "file" ? (
              typeof msg.messageContent === "string" ? (
                // (msg.messageContent.includes(
                //   "Analyze the summary and tell me \n"
                // )
                //   ? msg.messageContent.slice(
                //       msg.messageContent.indexOf(
                //         "Analyze the summary and tell me \n"
                //       ) + 33
                //     )
                //   : msg.messageContent
                // )
                //   .split("\n")
                //   .map((line, index) => (
                //     <React.Fragment key={index}>
                //       {line.includes("Image generation failed due to") ? (
                //         <i>
                //           <div className="prose max-w-none">
                //             <ReactMarkdown skipHtml={false}>
                //               {line}
                //             </ReactMarkdown>
                //           </div>
                //         </i>
                //       ) : (
                //         <div className="prose max-w-none">
                //           <ReactMarkdown
                //             remarkPlugins={[remarkGfm]}
                //             rehypePlugins={[rehypeHighlight]}
                //             skipHtml={false}
                //           >
                //             {line}
                //           </ReactMarkdown>
                //         </div>
                //       )}
                //       <br />
                //     </React.Fragment>
                //   ))
                <div className="chat-markdown">
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeHighlight]}
                    components={{
                      p: ({ children }) => (
                        <p style={{ marginBottom: "0.5em" }}>{children}</p>
                      ),
                      ul: ({ children }) => (
                        <ul
                          style={{ marginTop: "0.5em", marginBottom: "0.5em" }}
                        >
                          {children}
                        </ul>
                      ),
                      ol: ({ children }) => (
                        <ol
                          style={{ marginTop: "0.5em", marginBottom: "0.5em" }}
                        >
                          {children}
                        </ol>
                      ),
                      li: ({ children }) => (
                        <li style={{ marginBottom: "0.25em" }}>{children}</li>
                      ),
                      h1: ({ children }) => (
                        <h1 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                          {children}
                        </h1>
                      ),
                      h2: ({ children }) => (
                        <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                          {children}
                        </h2>
                      ),
                      h3: ({ children }) => (
                        <h3 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                          {children}
                        </h3>
                      ),
                      h4: ({ children }) => (
                        <h4 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                          {children}
                        </h4>
                      ),
                      code: ({ children, className, ...props }) => {
                        const inline = !className?.includes("language-");
                        return inline ? (
                          <code
                            style={{
                              backgroundColor:
                                theme.palette.mode === "dark"
                                  ? "rgba(255,255,255,0.1)"
                                  : "#f5f5f5",
                              padding: "2px 4px",
                              borderRadius: "3px",
                              fontSize: "0.9em",
                            }}
                            className={className}
                            {...props}
                          >
                            {children}
                          </code>
                        ) : (
                          <code className={className} {...props}>
                            {children}
                          </code>
                        );
                      },
                      pre: ({ children }) => (
                        <pre
                          style={{
                            overflow: "auto",
                            marginTop: "0.5em",
                            marginBottom: "0.5em",
                          }}
                        >
                          {children}
                        </pre>
                      ),
                    }}
                  >
                    {msg.messageContent}
                  </ReactMarkdown>
                </div>
              ) : (
                ""
              )
            ) : msg.messageType == "image" ? (
              <img
                src={msg.messageContent || ""}
                id={msg.message_id + "-image"}
                style={{ width: "200px", height: "200px", cursor: "pointer" }}
                onClick={() => setExpandImage(msg.messageContent)}
              />
            ) : (
              <i>{msg.messageContent}</i>
            )}
          </div>
        </div>
        <Dialog
          open={expandImage ? true : false}
          onClose={() => setExpandImage("")}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            "& .MuiDialog-paper": {
              backgroundImage: "initial",
              textAlign: "center",
              width: { xs: "80%", sm: "40%" },
              height: { xs: "80%", sm: "40%" },
              boxShadow: "0 0 5px #222 !important",
              borderRadius: "10px",
            },
          }}
        >
          <DialogContent
            sx={{ padding: "0px !important", overflow: "hidden !important" }}
          >
            <img
              src={expandImage || ""}
              id={msg.message_id + "-image"}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  return (
    <div className="messages" id="msgs-container">
      {props.messages.map((msg: MessageType, i) => message(msg, i))}
    </div>
  );
}
